import React, { useEffect, useState } from "react";
import { Paper, Divider, Button, Box, Typography } from "@mui/material";
import Projects from "./projects";
import axios from "axios";
import { CONFIG } from "../../../config";
import { useSelector, useDispatch } from "react-redux";
import { ToolBar } from "../../components/toolbar";
import { Modal } from "../../components/modal";
import { FormA } from "../../components/form";
import { getFormState, parseSavedData } from "../../../helpers/form";
import { Notice } from "../../components/notice";
import EditIcon from '@mui/icons-material/Edit';
import Profile from "./profile";

import IconButton from '@mui/material/IconButton';
import Stack from '@mui/material/Stack';
import DeleteIcon from '@mui/icons-material/Delete';
import AlarmIcon from '@mui/icons-material/Alarm';
import AddShoppingCartIcon from '@mui/icons-material/AddShoppingCart';
import {EditEmployee} from '../employee-management/edit';

const API_HOST = CONFIG.modules["accounts"].host;
const fieldsMap = {
    Lead: [
        {
            type: "select",
            label: "Select Team Lead",
            option: { key: "rms", value: "_id", label: "name" },
            required: true,
            name: "lead",
            multiple: true,
        },
    ],
    Member: [
        {
            type: "select",
            label: "Select Team Member",
            option: { key: "users", value: "_id", label: "name" },
            required: true,
            name: "members",
            multiple: true,
        },
    ],
};
const Teams = () => {
	const {
		
		map,
	} = useSelector((state) => state.user || {});
    const [department, setDepartment] = useState(null);
    const [open, setOpen] = useState(false);
    const [action, setAction] = useState("new");
    const [active, setActive] = useState("Lead");
    const [formData, setFormData] = useState(getFormState(fieldsMap[active]));
    const { users } = useSelector((state) => state.user || {});
    const [savedMessage, setSavedMessage] = useState(false);
    const [openDelete, setOpenDelete] = useState(false)

    const getSelectedDepartment = (id) => {
        axios
            .get(API_HOST + `/get-projects-or-departments/${id}`)
            .then((resp) => {
                if (resp.data && resp.data.success) {
                    if (resp.data.team.length > 0)
                        setDepartment(resp.data.team);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };

    const setSelectedDepartment = (data) => {
        setDepartment([{
            department: [],
            departmentType: data.type,
            lead: [],
            members: [],
            name: data.name,
            departmentId: data._id
        }])
    }

    const handleSubmit = () => {
        axios
            .put(API_HOST + `/add-team/${department[0]._id}`, {
                type: active,
                payload: formData,
                departmentId: department[0].departmentId,
                departmentType: department[0].departmentType
            })
            .then((resp) => {
                if (resp.data && resp.data.success) {
                    setDepartment([resp.data.team]);
                    setOpen(false);
                    setSavedMessage("Great! New Team Saved");
                    setTimeout(() => {
                        setSavedMessage(null);
                    }, 2000);
                }
            })
            .catch((e) => {
                console.log(e);
            });
    };
    // useEffect(() => {}, [department]);

    const [data, setData] = useState(null);
    const [openProfile, setOpenProfile] = useState(false);
    const [openTeam, setOpenTeam] = useState(false);
    const [leadName, setLeadName] = useState(null);
    const [editOpen, setEditOpen] = useState(false)
    

    const handleProfileData = (data) => {
        console.log('Check it',data);
        setData(data);
        setOpenProfile(true);
    }

    const handleOpenTeam = (lead) => {
        setLeadName(lead.name);
        setOpenTeam(true);
    }

    useEffect(() => {
        console.log('PRe', users)
        if (data) {
            console.log(data.name, data._id)
            console.log(users)
            const user = users.find(d=>data._id == d._id)
            console.log(user.name, user._id)
            if (user) {
                console.log('fucking user',user)
                setData({...user, departments: (user.departments || []).map(d=>d._id),
                    designation: (user.designation || []).map(d=>d._id),
                    assignedRoles: (user.assignedRoles || []).map(ar => ar._id)

                })
            }
        }
    }, [users])

    useEffect(()=> {
        console.log('changed data', data)
    }, [data])

    return (
        <>
            {savedMessage && <Notice text={savedMessage} />}
            <div className="section">
                {
                    !department &&
                    <Projects getSelectedDepartment={getSelectedDepartment} setSelectedDepartment={setSelectedDepartment} />
                }


                {department && department.length > 0 && (
                    <div className="">
                        <ToolBar
                            // name={active}
                            breadCrumbs={{
                                list: [
                                    {
                                        name: 'Teams', onClick: () => {
                                            console.log('coming here')
                                            setDepartment(null)
                                        }
                                    }
                                ], active: {
                                    name: 'Details',

                                }
                            }}
                        />
                        <Paper>
                            <div className="container">
                                <div>
                                    <div className="px-3">
                                        <div className="p-3">
                                            <div className="text-center m-2">
                                                <div>
                                                    <strong>
                                                        <h4> {department[0].name || department[0].department.name} </h4>
                                                    </strong>
                                                </div>
                                                <div>
                                                    Total -{" "}
                                                    {department[0].lead.length +
                                                        department[0].members.length}
                                                </div>
                                            </div>
                                            <Divider />
                                        </div>

                                        <div className="list my-3">
                                            <div className="row justify-content-end">
                                                <div className="m-2">
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => {
                                                            setActive("Lead");
                                                            setOpen(true);
                                                            if (department[0].lead.length > 0) {
                                                                setAction("edit");
                                                                const newData = { ...department[0] };
                                                                const parsedData = {
                                                                    ...parseSavedData(newData, fieldsMap[active]),
                                                                };
                                                                setFormData(parsedData);
                                                            } else {
                                                                setAction("new");
                                                                setFormData(getFormState(fieldsMap[active]));
                                                            }
                                                        }}
                                                    >
                                                        {department[0].lead.length > 0
                                                            ? "Edit Lead"
                                                            : "Add Lead"}
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="row justify-content-center">
                                                {department[0].lead.length > 0 &&
                                                    department[0].lead.map((lead) => (
                                                        <div className="col-md-2 mb-3 p-2" key={lead._id}>
                                                            <Paper elevation={3}>
                                                                <div className=" d-flex justify-content-end" role="button" onClick={() => handleProfileData(lead)}>
                                                                    {/* <span className=" bg-dark text-white m-2 rounded-circle p-1 px-2">
                                                                        <EditIcon fontSize="small" />
                                                                    </span> */}
                                                                    <Stack direction="row" spacing={1}>
                                                                        <IconButton aria-label="Profile">
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    </Stack>
                                                                </div>


                                                                <div className="text-center  py-3">
                                                                    <div className="img">
                                                                        <img
                                                                            src="https://t4.ftcdn.net/jpg/03/32/59/65/240_F_332596535_lAdLhf6KzbW6PWXBWeIFTovTii1drkbT.jpg"
                                                                            alt=""
                                                                            width={100}
                                                                            className="rounded-circle"
                                                                        />
                                                                    </div>
                                                                    <div>{lead.name}</div>
                                                                    <div className="small text-secondary">
                                                                        {lead.uuid}
                                                                    </div>
                                                                    <div>Team Lead</div>
                                                                    <a href="#" onClick={() => handleOpenTeam(lead)} >View Team</a>
                                                                </div>
                                                            </Paper>
                                                        </div>
                                                    ))}
                                            </div>
                                            <div className="mt-3">
                                                <Divider />
                                            </div>
                                        </div>

                                        <div className="list my-3">
                                            <div className="row justify-content-end">
                                                <div className="m-2">
                                                    <Button
                                                        variant="contained"
                                                        size="small"
                                                        onClick={() => {
                                                            setActive("Member");
                                                            setOpen(true);

                                                            if (department[0].members.length > 0) {
                                                                setAction("edit");
                                                                const newData = { ...department[0] };
                                                                const parsedData = {
                                                                    ...parseSavedData(newData, fieldsMap[active]),
                                                                };
                                                                setFormData(parsedData);
                                                            } else {
                                                                setAction("new");
                                                                setFormData(getFormState(fieldsMap[active]));
                                                            }
                                                        }}
                                                    >
                                                        {department[0].members.length > 0
                                                            ? "Edit Member"
                                                            : "Add Member"}
                                                    </Button>
                                                </div>
                                            </div>
                                            <div className="row justify-content-center">
                                                {department[0].members.length > 0 &&
                                                    department[0].members.map((member) => (
                                                        <div className="col-md-2 mb-3 p-2" key={member._id}>
                                                            <Paper elevation={3}>
                                                                <div className=" d-flex justify-content-end" role="button" onClick={() => handleProfileData(member)}>
                                                                    {/* <span className="text-white bg-dark m-2 rounded-circle p-1 px-2">
                                                                        <EditIcon fontSize="small" />
                                                                    </span> */}
                                                                    <Stack direction="row" spacing={1}>
                                                                        <IconButton aria-label="Profile">
                                                                            <EditIcon />
                                                                        </IconButton>
                                                                    </Stack>
                                                                </div>
                                                                <div className="text-center  py-3">
                                                                    <div className="img">
                                                                        <img
                                                                            src="https://t4.ftcdn.net/jpg/03/32/59/65/240_F_332596535_lAdLhf6KzbW6PWXBWeIFTovTii1drkbT.jpg"
                                                                            alt=""
                                                                            width={100}
                                                                            className="rounded-circle"
                                                                        />
                                                                    </div>
                                                                    <div>{member.name}</div>
                                                                    <div className="small text-secondary">
                                                                        {member.uuid}
                                                                    </div>
                                                                    <div>Tele Caller</div>
                                                                    {/* <a href="">View Team Lead</a> */}
                                                                </div>
                                                            </Paper>
                                                        </div>
                                                    ))}
                                            </div>
                                            <div className="mt-3">
                                                <Divider />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </Paper >
                    </div >
                )}
            </div >
            <Modal
                open={open}
                handleClose={() => {
                    setOpen(false);
                }}
                head={`${action == "new" ? "Add" : "Edit"} ${active}`}
                buttons={[
                    {
                        name: "Cancel",
                        onClick: () => {
                            setOpen(false);
                        },
                    },
                    {
                        name: action == "new" ? "Create" : "Save",
                        onClick: () => {
                            switch (action) {
                                case "new":
                                    handleSubmit();
                                    break;
                                case "edit":
                                    handleSubmit();
                                    break;
                                default:
                                    break;
                            }
                        },
                    },
                ]}
            >
                {Array.isArray(fieldsMap[active]) && (
                    <Box sx={{ mt: 2 }}>
                        <FormA
                            fields={fieldsMap[active]}
                            data={{
                                users,
                                rms: (users || []).filter((u) => u.isPMU),
                            }}
                            onChange={(name, value, multiple) => {
                                console.log("value", value);
                                formData[name] = value;
                                setFormData({ ...formData });
                            }}
                            state={formData || {}}
                        />
                    </Box>
                )}
            </Modal>



            {/* for profile modal  */}
            <Profile hideDelete={true} open={openProfile} data={data} setOpenProfile={setOpenProfile} 
				mapdata={map}
				onClickEdit={() => {
                        setEditOpen(true)
                        setOpenProfile(false)
                }}
                
				onClickDelete={() => {
                    setOpenDelete(true)
                }}
			/>
            {
                editOpen&&
                <EditEmployee saved={{...data,
                    departments: data.departments.map(d=>(map.Departments[d])),
                    designation: data.designation.map(d=>(map.Designations[d])),
                    assignedRoles: data.assignedRoles.map(t=>(map.TaskTypes[t])),
                   
                }}
                openDelete={openDelete}
                openIt={editOpen}
                onCloseDelete={()=> {
                    setEditOpen(false)
                    setOpenDelete(false)
                }}
                onClose={()=>{
                    setEditOpen(false)
                    setOpenProfile(true)
                }}
                />
            }
            

            {/* for view members under team lead  */}
            <Modal
                open={openTeam}
                handleClose={() => {
                    setOpenTeam(false);
                }}
                head={`Team Under (${leadName})`}
                buttons={[
                    {
                        name: "Cancel",
                        onClick: () => {
                            setOpenTeam(false);
                        },
                    },
                ]}
            >

                <div>
                {department && department.length > 0 && department[0].members.length > 0 &&
                                                    department[0].members.map((member) => (
                    <div className="row pl-3 pb-0" key={member._id}>
                        <div className="col-md-9 d-flex align-items-center">
                            <strong>{member.name}</strong> &nbsp; (<span className="font-italic">{member.uuid}</span>)
                        </div>
                        <div className="col-md-3">
                            <Stack direction="row" spacing={1}>
                                <IconButton aria-label="Profile">
                                    <EditIcon />
                                </IconButton>
                            </Stack>
                        </div>
                    </div>
                                                    ))}
                </div>
            </Modal>
        </>
    );
};

export default Teams;
